<template>
  <div class="flex flex-col gap-5">
    <div class="text-start">
      <h4 class="text-md font-bold">Replace cart item?</h4>
    </div>
    <div class="flex flex-col gap-5">
      <p class="text-sm" v-if="giftCart?.items?.length > 0">Your cart contains items from a different category. Do you want to replace your selection?</p>
      <p class="text-sm" v-else-if="isbothEMIProvider">Your cart has EMI products. To add this EMI product from a different provider, we’ll need to clear your cart. Continue?</p>
      <p class="text-sm" v-else-if="isEMIandDifferentProvider">Your cart has other items. To add this EMI product, we’ll need to clear your cart. Continue?</p>
      <p class="text-sm" v-else-if="isNonEMIandEMIProvider">Your cart has an EMI product. To add this item, we’ll need to clear your cart. Continue?</p>
      <p class="text-sm" v-else-if="isFandBDifferentProvider">Items already in cart. Your cart contains items from another restaurant. Would you like to replace your cart to add items from this restaurant?</p>
      <p class="text-sm" v-else-if="isFandBDifferentCategory">Your cart has items from a restaurant. To add items from another seller, we’ll need to replace your cart. Continue?</p>
      <p class="text-sm" v-else-if="isNonFandBDifferentFandB">Your cart has items from another seller. To order from this restaurant, we’ll need to replace your cart. Continue?</p>
      <p class="text-sm" v-else-if="isNonGroceryAndGrocery">Your cart has items from another seller. To add grocery items, we’ll need to replace your cart. Continue?</p>
      <p class="text-sm" v-else-if="isGroceryAndNonGrocery">Your cart has grocery items. To add items from another category, we’ll need to replace your cart. Continue?</p>
      <p class="text-sm" v-else>Your cart contains items from a different provider. Do you want to replace your selection?</p> 
      <!-- <p class="text-sm" v-else>Your cart contains items from a different category. Do you want to replace your selection?</p> -->
      <div class="inline-flex gap-12">
        <div class="w-1/2">
          <UButton size="xl" label="No" variant="outline" block @click="handleNoClick"/>
        </div>
        <div class="w-1/2">
          <UButton size="xl" label="Replace" block @click="replaceCartItem"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';

const { gtag } = useGtag();
const giftCart = useGiftCart();
const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  const userData = isAuthenticated ? {
    user_name: auth.user.first_name,
    user_phone: auth.user.phone,
    user_email: auth.user.email,
  } : {
    user_name: null,
    user_phone: null,
    user_email: null
  };
const emit = defineEmits(['success', 'close']);
const props = defineProps(['data']);
const isNLINCS = (src) => src?.toLowerCase?.() === 'nlincs';

const cart = useCart();
const { provider, items } = cart;

const isbothEMIProvider = computed(() =>{
  const mainProviderSrc = props.data?.provider?.provider_src;
  if(!isNLINCS(mainProviderSrc)) return false;
  return Array.isArray(items) && items.length > 0 && items.every(k => isNLINCS(k?.provider?.provider_src));
});

const isEMIandDifferentProvider = computed(() => {
  const mainProviderSrc = props.data?.provider?.provider_src;

  if (!isNLINCS(mainProviderSrc)) return false;

  return Array.isArray(items)
    ? items.every(k => !isNLINCS(k?.provider?.provider_src))
    : false;
});

const isNonEMIandEMIProvider = computed(() => {
  const mainProviderSrc = props.data?.provider?.provider_src;

  if (isNLINCS(mainProviderSrc)) return false;
  
  return Array.isArray(items)
    ? items.every(k => isNLINCS(k?.provider?.provider_src))
    : false;
});

const isFandBDifferentProvider = computed(() =>
  props.data?.category?.parent?.code?.toLowerCase() === 'f&b' && 
  provider && provider !== props.data?.provider?.ukid && 
  items.every(k => k.category?.parent?.code?.toLowerCase() === 'f&b')
);
const isFandBDifferentCategory = computed(() =>
  props.data?.category?.parent?.code?.toLowerCase() !== 'f&b' &&
  items.every(k => k.category?.parent?.code?.toLowerCase() === 'f&b')
);

const isNonFandBDifferentFandB = computed(() =>
  props.data?.category?.parent?.code?.toLowerCase() === 'f&b' && 
  items.every(k => k.category?.parent?.code?.toLowerCase() !== 'f&b')
);
const isNonGroceryAndGrocery = computed(() =>
  props.data?.category?.parent?.code?.toLowerCase() === 'grocery' && 
  items.every(k => k.category?.parent?.code?.toLowerCase() !== 'grocery')
);
const isGroceryAndNonGrocery = computed(() =>
  props.data?.category?.parent?.code?.toLowerCase() !== 'grocery' && 
  items.every(k => k.category?.parent?.code?.toLowerCase() === 'grocery')
);



const replaceCartItem = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'replace_cart_with_no_multiseller',
  })
  cart.clear();
  emit('success');
}

const handleNoClick = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'replace_cart_with_no_multiseller',
  });

  emit('close');
};
</script>
